import dayjs from 'dayjs'
import { SortOrder } from 'antd/lib/table/interface'
import { formatPrice } from '../../../utils'

export const getOrdersByManagerColumns = (showOffice: boolean) => {
  return [
    {
      title: 'Менеджер',
      dataIndex: 'manager',
      key: 'manager',
      width: '20%',
      sorter: {
        compare: (a, b) => a.isSubtotal ? 1 : a.manager.localeCompare(b.manager),
        multiple: 4,
      },
    },
    {
      title: 'Дата оплаты',
      dataIndex: 'orderDate',
      key: 'orderDate',
      width: '10%',
      sorter: {
        //@ts-ignore
        compare: (a, b) => new Date(a.orderDate) - new Date(b.orderDate),
        multiple: 1,
      },
      render: v => (v ? dayjs(v).format('DD/MM/YY') : '-'),
    },
    {
      title: 'Дата заявки',
      dataIndex: 'caseDate',
      key: 'caseDate',
      width: '10%',
      sorter: {
        //@ts-ignore
        compare: (a, b) => new Date(a.caseDate) - new Date(b.caseDate),
        multiple: 2,
      },
      render: v => (v ? dayjs(v).format('DD/MM/YY') : '-'),
    },
    {
      title: 'Договор',
      dataIndex: 'contractNum',
      key: 'contractNum',
      width: '12%',
    },
    {
      title: 'Номер производственного заказа',
      dataIndex: 'productionNum',
      key: 'productionNum',
      width: '12%',
    },
    {
      title: 'Сделка, дни',
      dataIndex: 'days',
      key: 'days',
      width: '5%',
      sorter: {
        compare: (a, b) => a.days - b.days,
        multiple: 3,
      },
      render: v => (v ? `${v}` : '-'),
    },
    {
      title: 'Клиент',
      dataIndex: 'clientName',
      key: 'clientName',
      width: '23%',
      sorter: {
        compare: (a, b) => a.manager.localeCompare(b.manager),
        multiple: 4,
      },
    },
    {
      title: 'Продажи',
      dataIndex: 'sum',
      key: 'sum',
      width: '20%',
      sorter: {
        compare: (a, b) => a.sum - b.sum,
        multiple: 5,
      },
      render: v => formatPrice(v),
    },
  ]
}
